import {
  ANALYTICS_ACTION_CLICKED,
  ANALYTICS_SUBJECT_BUTTON,
  UI_EVENT_TYPE,
} from '@atlassian/mpac-analytics';

import bootstrapConfig from '../../../app/bootstrapConfig';

export const EVENT_CONTAINER_APP_HEADER = 'appHeader';
export const EVENT_CONTAINER_NAV_BAR = 'navBar';
export const EVENT_CONTAINER_SITE_SELECTOR = 'siteSelector';
export const EVENT_CONTAINER_APP_LISTING_PRICING_TAB = 'appListingPricingTab';
export const EVENT_CONTAINER_CERTIFICATION_SECTION = 'certificationSection';

const EVENT_CONTAINER_ADDON_DISCOVERY = 'addonDiscovery';

export const trackEvent = ({
  eventContainer,
  eventComponent,
  eventName,
  actionSubjectId,
  event,
  label,
  ...additionalProperties
}) => {
  try {
    // @ts-expect-error [MC-2850] - TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'.
    window?.ace?.analytics.Tracking.trackEvent(eventName, {
      eventType: UI_EVENT_TYPE,
      eventContainer,
      eventComponent,
      actionSubjectId,
      event,
      label,
      schemaVersion: 1,
      featureFlags: bootstrapConfig.get().featureFlags,
      ...additionalProperties,
    });
  } catch (error: any) {
    console.error('ace.analytics.Tracking.trackEvent threw an error', error);
  }
};

export const trackPageView = (referrer: any, name: any, additionalProperties: any) => {
  const bootstrap = bootstrapConfig.get();
  // @ts-expect-error [MC-2850] - TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'. | TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'. | TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'.
  if (window.ace && window.ace.analytics && window.ace.mkt) {
    try {
      // @ts-expect-error [MC-2850] - TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'.
      window?.ace?.analytics.Tracking.pageView(name, name, {
        referrer,
        // @ts-expect-error [MC-2850] - TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'.
        context_atl_path: window.ace.mkt.Cookie.readCookie('__atl_path') || '',
        // @ts-expect-error [MC-2850] - TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'.
        utmz: window.ace.mkt.Cookie.readCookie('__utmz') || '',
        // @ts-expect-error [MC-2850] - TS2339 - Property 'ace' does not exist on type 'Window & typeof globalThis'.
        ga_clientid: window.ace.mkt.Cookie.readCookie('_ga') || '',
        featureFlags: bootstrap.featureFlags,
        screenNameOverride: name,
        ...additionalProperties,
      });
    } catch (error: any) {
      console.error('ace.analytics.Tracking.pageView threw an error', error);
    }
  }
};

export const trackAppListing = ({
  eventContainer,
  eventComponent,
  eventName,
  actionSubjectId,
  event,
  label,
  appKey,
  hosting,
  ...additionalProperties
}) =>
  trackEvent({
    eventContainer,
    eventComponent,
    eventName,
    actionSubjectId,
    event,
    label,
    category: 'appListing',
    appKey,
    hosting,
    ...additionalProperties,
  });

export const trackTryModal = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Try-Modal-Trigger',
    actionSubjectId: 'tryModalTrigger',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Try it free',
    appKey,
    source: 'appListingPage',
    hosting,
    paymentModel,
  });

export const trackBuyModal = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Buy-Modal-Trigger',
    actionSubjectId: 'buyModalTrigger',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Buy it now',
    appKey,
    source: 'appListingPage',
    hosting,
    paymentModel,
  });

export const trackTryButton = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Try',
    actionSubjectId: 'installButton',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Start Free Trial',
    appKey,
    source: 'selectHostingModel',
    hosting,
    paymentModel,
  });

export const trackBuyButton = ({ appKey, hosting, paymentModel }) =>
  trackAppListing({
    eventContainer: EVENT_CONTAINER_APP_HEADER,
    eventComponent: ANALYTICS_SUBJECT_BUTTON,
    eventName: 'Clicked-Buy',
    actionSubjectId: 'installButton',
    event: ANALYTICS_ACTION_CLICKED,
    label: 'Subscribe Now',
    appKey,
    source: 'selectHostingModel',
    hosting,
    paymentModel,
  });

export const trackAddonDiscovery = ({
  eventName,
  actionSubject,
  actionSubjectId,
  action,
  label,
  payload,
}) =>
  trackEvent({
    eventContainer: EVENT_CONTAINER_ADDON_DISCOVERY,
    eventComponent: actionSubject,
    eventName,
    actionSubjectId,
    event: action,
    label,
    category: 'addonDiscovery',
    ...payload,
    ...payload.attributes,
  });

// Manage apps track events
export const trackManageApps = ({
  eventContainer,
  actionSubject,
  action,
  actionSubjectId,
  ...additionalProperties
}) =>
  // @ts-expect-error [MC-2850] - TS2345 - Argument of type '{ eventContainer: any; eventComponent: any; event: any; actionSubjectId: any; category: string; }' is not assignable to parameter of type '{ [x: string]: any; eventContainer: any; eventComponent: any; eventName: any; actionSubjectId: any; event: any; label: any; }'.
  trackEvent({
    eventContainer,
    eventComponent: actionSubject,
    event: action,
    actionSubjectId,
    category: 'manageApps',
    ...additionalProperties,
  });

// Manage partner pages track events
export const trackManagePartnerAccount = ({
  eventContainer,
  actionSubject,
  action,
  actionSubjectId,
  ...additionalProperties
}) => {
  // @ts-expect-error [MC-2850] - TS2339 - Property 'vendorData' does not exist on type 'Readonly<{ adminHubBaseUrl: string; graphQLGatewayUrl: string; mpacBaseUrl: string; mpacCdnBaseUrl: string; macBaseUrl: string; wacBaseUrl: string; atlassianCommunityBaseUrl: string; jiraServiceDeskEmbedBaseUrl: string; ... 8 more ...; analyticsClient: AnalyticsClientInterface; }>'.
  const vendorData = bootstrapConfig.get().vendorData;
  const commonVendorAttributes =
    vendorData?.id && vendorData?.name
      ? {
          partnerId: vendorData.id,
          partnerName: vendorData.name,
        }
      : {};
  // @ts-expect-error [MC-2850] - TS2345 - Argument of type '{ partnerId: any; partnerName: any; eventContainer: any; eventComponent: any; event: any; actionSubjectId: any; category: string; } | { partnerId?: undefined; partnerName?: undefined; eventContainer: any; eventComponent: any; event: any; actionSubjectId: any; category: string; }' is not assignable to parameter of type '{ [x: string]: any; eventContainer: any; eventComponent: any; eventName: any; actionSubjectId: any; event: any; label: any; }'.
  trackEvent({
    eventContainer,
    eventComponent: actionSubject,
    event: action,
    actionSubjectId,
    category: 'managePartner',
    ...commonVendorAttributes,
    ...additionalProperties,
  });
};
